import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    input,
    signal,
    WritableSignal
} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {IconButtonComponent} from "../../buttons/icon-button/icon-button.component";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import {TranslateModule} from '@ngx-translate/core';
import {FieldComponent} from '../field/field.component';

@Component({
    selector: "woa-password-field",
    templateUrl: "./password-field.component.html",
    styleUrl: "./password-field.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: PasswordFieldComponent, multi: true}],
    imports: [
        FieldComponent,
        FormsModule,
        IconButtonComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordFieldComponent extends AbstractField {
    public readonly autocomplete: InputSignal<"current-password" | "new-password"> = input.required<"current-password" | "new-password">();

    public readonly maxlength: InputSignal<string> = input<string>("20");

    IconButtonType = IconButtonType;

    public showPassword: WritableSignal<boolean> = signal(false);

    toggleShowPassword() {
        this.showPassword.update(value => !value);
    }
}
